export default "__VITE_PUBLIC_ASSET__a254694b__"